import { RouteNames } from "@/router/RouteNames";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { inject } from "vue";
import { useRouter } from "vue-router";

export function useAiAutoLoginAction() {
  const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
  const router = useRouter();

  const lockProperty = async (propertyId: number, lock: boolean) => {
    await apiClient.httpPostVoid(`database/properties/${propertyId}/lock`, {
      lock: lock,
    });
  };

  const navigateToProperty = (propertyId: number) => {
    router.push({
      name: RouteNames.PropertyPage,
      params: { propertyid: propertyId.toString() },
    });
  };

  return {
    lockProperty,
    navigateToProperty,
  };
}
